<!--
 * @Description: 客户账号详情-基本信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-02-24 15:55:52
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search">
    <detail-card :columns="columns" title="基础信息" :data="data" />
  </a-form>
</template>
<script lang="ts">
import { ref, reactive, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { customerCodeDetail } from '@/api/gucangSales/customerCenter'
import { customerPhaseEnum, arkCodeStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
export default { name: 'BaseMessage' }
</script>
<script setup lang="ts">
const props = defineProps({
  id: {
    type: String
  }
})
const columns = ref([
  { title: '子客户代码', dataIndex: 'arkCode' },
  {
    title: '客户阶段',
    dataIndex: 'stage',
    node: 'cos-select',
    attrs: {
      options: customerPhaseEnum
    }
  },
  { title: '子客户代码名称', dataIndex: 'arkAccount' },
  { title: '档次', dataIndex: 'level' },
  { title: '联系人', dataIndex: 'arkContactName' },
  { title: '成交金额（万）', dataIndex: 'amount' },
  { title: '手机号', dataIndex: 'arkContactMobile' },
  { title: '更新时间', dataIndex: 'updateTime' },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '创建时间', dataIndex: 'createTime' },
  {
    title: 'ark账号状态',
    dataIndex: 'status',
    node: 'cos-select',
    attrs: {
      options: arkCodeStatusEnum
    }
  }
])
const data = reactive({})
const fetch = () => {
  if (props.id) {
    customerCodeDetail(props.id).then((res) => {
      Object.assign(data, res.data)
    })
  }
}
onMounted(() => {
  fetch()
})
</script>
